import Lottie from 'lottie-react';
import AnalysisActiveJSON from '../jsons/analysis-active.json';

const AnalysisActive = props => {
  return <Lottie animationData={AnalysisActiveJSON} loop={true} {...props} />;
};

export default AnalysisActive;